import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    marginBottom: 32,
    height: 300,
    padding: 30
  },
  selectBoxes: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  boxContainerRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: 12,
    marginBottom: 12
  },
  searchBoxContainerRow: {
    marginTop: 20
  },

  ButtonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end'
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  },
  applyButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[200]}`
  },
  resetButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[700]}`
  },
  inventoryTypeRadioGroup: {
    display: 'flex',
    flexDirection: 'row'
  },
  inventoryTypeSelector: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    width: '100%',
    flex: 1
  },
  inventoryTypeSelectorLabel: {
    marginRight: 100,
    [theme.breakpoints.down('sm')]: {
      marginRight: 59
    }
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    // marginTop: 29,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'left',
      padding: '0 10px'
    }
  },
  switch: {
    width: 'auto',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
